module.exports = __webpack_public_path__ + "img/3m.2ad3952a.jpg";